import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormUtility } from '../../Utility/FormUtility';
import ToastContext from '../../../contexts/toast';
import { BandoService } from '../../../services/BandoService';
import { RevocheService } from '../../../services/RevocheService';
import StatusContext from '../../../contexts/status';
import Select from '../../Form/Select';
import Input from '../../Form/Input';
import TextArea from '../../Form/TextArea';
import Upload from '../../Form/Upload';

export default function GestioneGruppoRevoche() {
    const [validate, setValidate] = useState(false);
    const [inputErrors, setInputErrors] = useState([]);
    const [bandi, setBandi] = useState(null);
    const [file, setFile] = useState(null);
    const [errorMessageFile,setErrorMessageFile] = useState(null);

    const [gruppo, setGruppo] = useState({});

    const bandoService = new BandoService();

    const revocheService = new RevocheService();

    const utility = new FormUtility();

    const toastContext = useContext(ToastContext);

    const statusContext = useContext(StatusContext);
    const params = useParams();
    const navigation = useNavigate();
    const formRef = useRef(null);

    const validExtensions = ["csv"];

    const paramId = params.id;//se facciamo edit

    const uploadRef = useRef(null);

    const onFileChanged = async (file) => {
        setErrorMessageFile(null);
        setFile(file);
    /*setDisabledConfirmBtn(true);
    setValidazioneVisible(false);
    setValidazioneOk(false);
    setEsitoImportazione(false);
    setFile(null);
    setReportData(null);*/
  };
  const onUploadOk = async () => {

  };
  const validaFile = async (fileToValidate) => {
    setFile(fileToValidate);
    return {ok:true};    
  };
  const onValidationDone = async (data, selectedFile) => {
    setFile(selectedFile);
  };


    useEffect(() => {
        bandoService.getAll().then((resp) => {
            setBandi(resp);
        });

        /*if (paramId) {
          faseService
            .getById(paramId)
            .then((resp) => {
              setFase(resp);
              completeMapDate(resp);
              setAssociablePresentazioneDomande(
                [
                  tipologieFase.istruttoria,
                  tipologieFase.secondo_accesso_non_ammessi_sospesi,
                  tipologieFase.terzo_accesso_sospesi,
                  tipologieFase.aggiornamento_isee,
                  tipologieFase.annullamento_domande
                ].includes(resp.tipologia)
              );
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          completeMapDate(fase);
        }*/

        return () => {
            statusContext.removeEvent('onbeforeunload');
        };
    }, []);

    const onChangeBando = (event) => {
        const value = event.target.value;
        const bando = value ? bandi.find((b) => b.id === parseInt(value)) : null;

        setGruppo({
            id: gruppo.id,
            nomeGruppo: gruppo.nomeGruppo,
            bando: bando
        });
        statusContext.addEvent('onbeforeunload');
    };
    const onChangeValue = async (event) => {
        const target = event.target;
        gruppo[target.name] = target.value;
        setGruppo({ ...gruppo });
        statusContext.addEvent('onbeforeunload');
    };

    const setFormErrors = (setFocus = true) => {
        const errors = utility.getAllInputErrors(formRef);
        setInputErrors(errors.map((el) => el.id));
        if (setFocus && errors.length > 0) {
            errors[0].focus();
        }
    };
    const denyOperation = () => {
        navigation(`/gestione-revoche`);
    };

    const sendData = (event) => {
        event.preventDefault();
        event.stopPropagation();

        setValidate(true);

        const validity = formRef.current.checkValidity();
        if (!validity) {
            setFormErrors();
            return;
        }
        if (!file){
            setErrorMessageFile('Campo obbligatorio');
            toastContext.error("Selezionare un file CSV contenente l'elenco dei codici delle domande", 12000);
            return;
        }

        setInputErrors([]);

            gruppo.bando = gruppo.bando_id
            ? bandi.find((b) => b.id === parseInt(gruppo.bando_id))
            : gruppo.bando;
            gruppo.bandoId = gruppo.bando.id;
            
    


        const service = paramId ? revocheService.update : revocheService.create;
        service(gruppo,file)
            .then(() => {
                toastContext.success(
                    'Gruppo ' + (paramId ? 'aggiornato' : 'aggiunto') + ' con successo!',
                    4000
                );
                statusContext.removeEvent('onbeforeunload');

                setTimeout(() => {
                    navigation(`/gestione-revoche`);
                }, 100);
            })
            .catch((error) => {
                toastContext.error(utility.getErrorMsg(error), 12000);
            });
    };



    return (
        <div className='rtds-container rtds-my-12'>
            <div className='rtds-mb-6'>
                <h1 className='rtds-text-2xl rtds-font-bold'>
                    {paramId ? 'Modifica Gruppo Di Revoche' : 'Inserisci Gruppo Di Revoche'}
                </h1>
            </div>
            <div className='rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02'>
                <div className='rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02'>
                    <p>
                        I campi obbligatori sono contrassegnati da un asterisco&nbsp;
                        <abbr
                            className='rtds-font-bold rtds-no-underline'
                            title='obbligatorio'
                        >
                            *
                        </abbr>
                    </p>
                </div>

                <form
                    noValidate
                    ref={formRef}
                    id='hasValidationForm'
                    className='has-js-validation-form rtds-py-6 rtds-space-y-4'
                    onSubmit={sendData}
                >
                    <Input
                        label={'Nome del gruppo'}
                        required
                        id={'nomeGruppo'}
                        inputErrors={inputErrors}
                        classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
                        type={'text'}
                        onChange={(event) => onChangeValue(event)}
                        value={gruppo.nomeGruppo || ''}
                        maxLength={50}
                        disabled={paramId}
                    />
                    <Select
                        classDiv={'rtds-mt-3 lg:rtds-mt-0'}
                        label={'Avviso'}
                        required
                        id={'avviso'}
                        inputErrors={inputErrors}
                        classSelect={''}
                        onChange={(event) => onChangeBando(event)}
                        baseOption={'Seleziona Avviso'}
                        bindKey={'id'}
                        bindValue={'nome'}
                        options={bandi}
                        value={gruppo?.bando?.id || gruppo?.bando_id || ''}
                        disabled={!!paramId}
                    />

                    <Upload
                        ref={uploadRef}
                        id={"fileExcel"}
                        onFileChanged={onFileChanged}
                        onUploadOk={onUploadOk}                        
                        caricaVisible={false}
                        label={"Elenco domande *"}
                        validExtensions={validExtensions}
                        funzioneValidazioneEsterna={validaFile}
                        onValidationDone={onValidationDone}
                        required
                    />
                    { errorMessageFile &&
                    <div>
                        <span className="rtds-input-field__error">{errorMessageFile}</span>
                    </div>
                    }

                    <Input
                        label={'Oggetto dell\'email'}
                        required
                        id={'oggetto'}
                        inputErrors={inputErrors}
                        classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
                        type={'text'}
                        onChange={(event) => onChangeValue(event)}
                        value={gruppo.oggetto || ''}
                        maxLength={500}
                        disabled={paramId}
                    />
                    <TextArea
                        label={"Corpo dell\'email"}
                        id={"body"}
                        required
                        inputErrors={inputErrors}
                        classTextArea={"rtds-text-sm rtds-input-placeholder rtds-pr-12"}
                        type={"text"}
                        onChange={(event) => onChangeValue(event)}
                        value={gruppo.body || ""}
                        disabled={paramId}
                        style={{ height: "200px" }}

                    />

                    <div className='rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center'>
                        <div className='rtds-form-actions'>
                            <div
                                className='rtds-inline-flex rtds-gap-1'
                                role='group'
                                aria-label='Azioni'
                            >
                                <button
                                    type='button'
                                    className='rtds-btn rtds-btn--secondary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                                    onClick={() => denyOperation()}
                                >
                                    <svg
                                        className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6  group-hover/button:-rtds-translate-x-1'
                                        aria-hidden='true'
                                        focusable='false'
                                        role='img'
                                    >
                                        <use
                                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                                        />
                                    </svg>{' '}
                                    Annulla
                                </button>
                                <button
                                    type='submit'
                                    className='rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button'
                                >

                                    Salva
                                    <svg
                                        className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                                        aria-hidden='true'
                                        focusable='false'
                                        role='img'
                                    >
                                        <use
                                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${paramId
                                                ? 'solid--chevron-right'
                                                : 'solid--chevron-right'
                                                }`}
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}